module.exports = __webpack_public_path__ + "assets/images/instruct-path.a71a26a0db3454eb193d4734c5f966c7.svg";